export default "__VITE_ASSET__BtZSa8pG__"